import { Component, OnInit } from '@angular/core';
import { SeoService } from 'src/app/services/seo.service';

@Component({
  selector: 'v2m-utility-film-definition',
  templateUrl: './utility-film-definition.component.html',
  styleUrls: ['./utility-film-definition.component.scss']
})
export class UtilityFilmDefinitionComponent implements OnInit {
  constructor(private seo: SeoService) {}

  ngOnInit() {
    this.seo.updateTitle('video2manual - Video-Anleitung');
    this.seo.updateKeywords('Video-Anleitung,Utility Film');
  }
}
